<template>
  <v-snackbar
    v-model="snackbarVisible"
    :color="snackbarBackgroundColor"
    top
    right
    multi-line
    :timeout="timeout"
    height="78"
    max-width="320"
  >
    <div class="d-flex">
      <div
        v-if="statusIcon"
        class="d-flex align-center justify-center"
        :class="`snackbar__status snackbar__status--${status}`"
      >
        <apio-icon
          :name="statusIcon"
          lightModeColour="white"
          darkModeColour="white"
          size="16"
        />
      </div>
      <div class="d-flex align-center flex-grow-1" :class="{ 'snackbar__text-color--dark' : isDarkMode,  'snackbar__text-color--light' : !isDarkMode }" style="width: 100%" v-html="text"></div>
        <v-spacer />
        <div class="d-flex align-center">
          <apio-icon
            name="cross"
            lightModeColour="black"
            darkModeColour="white"
            @click.native="$emit('close')"
            size="16"
          />
      </div>
    </div>
    <template v-slot:action="{ }">
      <div     :color="snackbarBackgroundColor"
 style="width: 10px; height:100%; margin: auto 0;" />
    </template>
  </v-snackbar>
</template>

<script>

export default {
  name: "ApioSnackbar",
  props: {
    status: {
      type: String,
    },
    text: {
      type: String,
    },
    snackbar: {
      type: Boolean,
    },
    timeout: {
      type: String,
      default: "6000",
    }
  },
  data() {
    return {
      // snackbar: false,
      // snackBarText: "",
      // snackBarStatus: null,
      snackbarVisible: this.snackbar
    };
  },
  watch: {
    snackbar(newValue) {
      if (newValue !== this.snackbarVisible) this.snackbarVisible = newValue;
    },
    snackbarVisible(newValue) {
      if(newValue === false) {
        setTimeout(() => {
          this.$emit('close');
        }, 2000);
      }
    }
  },
  computed: {
    statusIcon() {
      if (this.status === "error") {
        return "ui-error";
      }
      if (this.status === "warning") {
        return "ui-warning-circle";
      }
      if (this.status === "success") {
        return "ui-circle-tick-fill";
      }
      return "";
    },
    isDarkMode() {
      return this.$store.state.mode.darkMode
    },
    snackbarTextColor() {
      return this.isDarkMode ? 'apioshade2' : 'white';
    },
    snackbarBackgroundColor() {
      return this.isDarkMode ? 'apioshade2' : 'white';
    }
  },
};
</script>

<style lang="scss" scoped>

// .v-snack__wrapper.v-sheet.theme--light{
//   background: white;
//   color: var(--apio-shade-2);
// }

// .v-snack__wrapper.v-sheet.theme--dark {
//   background: var(--apio-shade-2);
//   color: white;
// }

::v-deep .v-snack__content {
  padding: 14px 0 14px 16px !important;
}

::v-deep .snackbar {
  &__text-color {
    &--dark {
      color: white !important;
    }
    &--light {
      color: var(--apio-shade-2)  !important;
    }
  }

  &__status {
    width: 32px;
    content: "";
    height: 78px;
    position: relative;
    left: -16px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    &--error {
      border: 1px solid var(--apio-error);
      background-color: var(--apio-error);
    }
    &--success {
      border: 1px solid var(--apio-success);
      background-color: var(--apio-success);
    }
    &--warning {
      border: 1px solid var(--apio-warning);
      background-color: var(--apio-warning);
    }
  }

  &__background-color {
    &--light {
      background: #fff;
      color: var(--apio-shade-2);
    }
    &--dark {
      background: var(--apio-shade-2);
      color: white;
    }
  }
}
</style>